const clubGuid = 'BVBL1189';
const vblClubName = 'Oxaco BBC Boechout ';

exports.clubGuid = clubGuid;
exports.vblClubName = vblClubName;
